// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1T3S1","logo":"App_logo__2aWG3","menu":"App_menu__K_aUC","title":"App_title__1dE9Z","footer":"App_footer__1Fjds"};